import { action } from 'satcheljs';
import { OWAConnectedAccount } from './schema/OWAConnectedAccount';

/**
 * Adds an account to the store.
 * The store responds by loading the user configuration of this account.
 */
export const addOWAConnectedAccount = action('addAccount', (account: OWAConnectedAccount) => ({
    primarySmtpAddress: account.primarySmtpAddress,
    account,
}));

/**
 * Removes an account to the store.
 */
export const removeOWAConnectedAccount = action('removeAccount', (primarySmtpAddress: string) => ({
    primarySmtpAddress,
}));

/**
 * Updates an account to the store.
 */
export const updateOWAConnectedAccountToken = action(
    'updateAccount',
    (primarySmtpAddress: string, accountToken: string, accountTokenExpiresIn: string) => ({
        primarySmtpAddress: primarySmtpAddress,
        accountToken: accountToken,
        accountTokenExpiresIn: accountTokenExpiresIn,
    })
);

/**
 * Updates the OWA Connected account status
 */
export const updateOWAConnectedAccountStatus = action(
    'updateOWAConnectedAccountStatus',
    (primarySmtpAddress: string, isAccountValid: boolean) => ({
        primarySmtpAddress,
        isAccountValid,
    })
);
